<template>
  <div>
    <a-modal width="850px" v-model="isShow" title="类型管理" :footer="null" :afterClose="handleCancel"
             :maskClosable="false">

      <a-form :model="searchFormType" :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <a-form-item label="类型名称">
              <a-input v-model="searchFormType.name" allowClear placeholder="请输入类型名称" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <a-form-item label="状态">
              <a-select v-model="searchFormType.status" allowClear show-search option-filter-prop="children"
                        placeholder="请选择状态" style="width: 100%">
                <a-select-option value="1">
                  启用
                </a-select-option>
                <a-select-option value="2">
                  禁用
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>

      <!-- 搜索按钮 -->
      <div class="flex-sb">
        <div>
          <a-button type="primary" icon="plus-circle" @click="handleAdd">新增</a-button>
        </div>
        <div>
          <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
          <a-button type="primary" ghost icon="delete" @click="handleClear">清空</a-button>
          <!-- <a-button icon="sync">刷新表格</a-button> -->
        </div>
      </div>

      <!-- 表格 -->
      <a-table size="middle" row-key="id" :columns="columnsType" :loading="loading" :data-source="data"
               :scroll="{ x: true }" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
        <template slot="format" slot-scope="text">
          <span>{{ showName('FORMAT', text) }}</span>
        </template>
        <template slot="user_id" slot-scope="text, record">
          <p style="margin:0;">{{ record.creator_name }}({{ record.creator_number }})</p>
        </template>
        <template slot="create_at" slot-scope="text, record">
          <p style="margin:0;">{{ time(record.created_at) }}</p>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch :checked="format(Number(record.status))" checked-children="启用" un-checked-children="禁用"
                    @change="(val) => checkedChange(val, record)" />
        </template>
        <template slot="operator" slot-scope="text, record">
          <div class="flex-sb">
            <a-button size="small" v-if="Number(record.status) === 2" type="link"
                      @click="handleTableCommand('edit', record)">编辑</a-button>
            <span v-else>-</span>
          </div>
        </template>
      </a-table>
      <!-- 添加 -->
      <addType v-model="visible" :isEdit="isEdit" :params="waitItem" @handleOver="getTypeList" />
    </a-modal>
  </div>
</template>
<script>
import { reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { strategyCommandType } from './business/tableLogic'
import { searchFormType, columnsType } from './business/frequencySet'
import pagination from '@/composables/pagination'
import addType from './addType.vue'
import compuedFun from './computed'
import api from '@/api/'
import dialog from '@/composables/dialog'
import moment from 'moment'
export default {
  mixins: [dialog],
  props: {
    params: {
      type: [Object, Array],
      default: () => ({})
    },
    visibleType: {
      type: Boolean,
      default: false
    },
  },
  components: { addType },
  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      columnsType,
      searchFormType: { ...searchFormType },
      // isShow: false
    })

    onMounted(async () => {
      methods.getTypeList()
    })

    const methods = {
      time(time) {
        return (time = moment(time * 1000).format('YYYY-MM-DD HH:mm:ss'))
      },
      search() {
        _this.pagination.current = 1
        this.getTypeList()
      },
      handleAdd() {
        _this.visible = true
        _this.isEdit = false
      },
      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommandType[type].call(_this, ...arg)
      },
      checkedChange(val, record) {
        const params = {
          id: record.id,
          status: val ? 1 : 2,
          name: record.name,
          format: record.format
        }
        const updateRecord = (status) => {
          record.status = status
          this.$message.success('操作成功~')
          this.getTypeList()
        }
        const handleError = () => {
          record.status = !val
        }
        const handleResponse = (res) => {
          if (res.code === '000000') {
            updateRecord(val)
          } else {
            handleError()
          }
        }
        const handleConfirm = async () => {
          try {
            const res = await api.contactTypeUpdate(params)
            handleResponse(res)
          } catch (error) {
            handleError()
          }
        }
        if (!val) {
          this.$confirm({
            title: '禁用',
            content: '禁用后，会影响历史数据使用该类型的公共信息展示。确认禁用？',
            cancelText: '取消',
            okText: '确认',
            async onOk() {
              await handleConfirm()
            },
          })
        } else {
          handleConfirm()
        }
      },
      async getTypeList() {
        _this.loading = true
        const res = await api.contactTypeListData({
          ...state.searchFormType,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const frequencyList = res?.data?.list || []
        const pagination = res?.data?.pagination || _this.pagination
        _this.data = frequencyList
        //  _this.data = frequencyList.map(item => {
        //   item.state = Number(item.state) === 1
        //   return item
        // })
        _this.pagination.total = pagination.total
        _this.loading = false
      },
      changeIsShow(params) {
        api.updateInterviewIsShow(params).then((res) => {
          this.getTypeList()
        })
      },
      format(value) {
        return value === 1
      },
      handleClear() {
        state.searchFormType = { ...searchFormType }
        this.search()
      },
      handleCancel() {
        _this.isShow = false
      },
    }

    return {
      ...toRefs(state),
      ...pagination(),
      ...compuedFun(),
      ...methods,
    }
  },
}
</script>
